import { MAX_FILE_MB } from '../constants';
import { processImage } from './image';

function readAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error || new Error('File read failed'));
    reader.readAsDataURL(file);
  });
}

export async function processAttachment(file) {
  if (!file) throw new Error('Missing file');
  const maxBytes = MAX_FILE_MB * 1024 * 1024;
  if (file.size > maxBytes) throw new Error(`File exceeds ${MAX_FILE_MB} MB limit`);

  if (file.type?.startsWith('image/')) {
    const image = await processImage(file);
    return {
      ...image,
      name: file.name || `screenshot-${Date.now()}.jpg`,
      mimeType: file.type || 'image/jpeg',
      size: file.size || 0
    };
  }

  return {
    id: `file-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type: 'file',
    name: file.name || 'attachment',
    mimeType: file.type || 'application/octet-stream',
    size: file.size || 0,
    dataRef: await readAsDataUrl(file),
    caption: '',
    addedAt: Date.now()
  };
}

export function formatFileSize(bytes = 0) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}